<template>
  <div class="header-tracking-component">
    <NuxtLink :to="getLocalizedRoute(Routes.ShipmentTracking.Tracking)" class="flex">
      <span class="icon w-4 h-4 mr-2" v-html="Icon" />
      {{ shipmentTrackingTitle }}
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
import getLocalizedRoute from '~/utils/getLocalizedRoute'
import Icon from '@/assets/icons/packing.svg?raw'
import { Routes } from '~/enums/Routes'

const { t } = useLang()
const shipmentTrackingTitle = computed(() => t('common.shipment-tracking'))
</script>

<style lang="scss" scoped>
.header-tracking-component {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  font-size: theme('fontSize.sm');
  color: theme('colors.text1');
  // Dark mode text color via @apply
  @apply dark:text-dmText1;

  .icon {
    :deep(svg) {
      width: 18px;
      height: 18px;

      path {
        @apply dark:!fill-white;
      }
    }
  }
}

.alt .header-tracking-component {
  a {
    color: theme('colors.white');
    @apply dark:text-black;
  }

  .icon {
    width: 18px;
    height: 18px;

    :deep(svg) {
      width: 18px;
      height: 18px;

      path {
        fill: theme('colors.white');
      }
    }
  }
}

.wl .header-tracking-component {
  svg {
    display: none;
  }
}

.ae .header-tracking-component {
  font-weight: 800;
  padding-left: 2.25rem;
  padding-right: 2.25rem;

  .icon {
    :deep(svg) {
      path {
        fill: theme('colors.text1');
      }
    }
  }

  a {
    color: theme('colors.text1');
    &:hover {
      color: theme('colors.text1');
    }
  }
}
</style>
